import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { AppDisplayService } from './core/services/app-display.service';
import { LoggerService } from './core/services/logger.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterOutlet],
})
export class AppComponent {
  private readonly auth = inject(AuthService);
  private readonly logger = inject(LoggerService);
  readonly appDisplay = inject(AppDisplayService);

  constructor() {
    this.auth
      .redirectUrlChanged$()
      .pipe(takeUntilDestroyed())
      .subscribe(url => this.logger.debug('Current redirect URL:', url));
  }
}
